import {
    MEASURE_DASHBOARD_ROUTER,
    MEASURE_DETAIL_ROUTER,
    MEASURE_EVALUATION_ROUTER,
    MEASURE_REPORT_ROUTER,
    MEASURE_RESULT_ROUTER,
    MEASURE_ROUTER,
    MEASURE_TRANSCRIPT_ROUTER,
} from '@Router/routerPath';
import { MeasurementPage } from '@Local/Measurement';

const MeasurementRouter = [
    {
        description: '量身',
        static: true,
        path: MEASURE_ROUTER,
        href: MEASURE_ROUTER,
        as: MeasurementPage,
    },
    {
        description: '量身主頁',
        static: true,
        path: MEASURE_DASHBOARD_ROUTER,
        href: MEASURE_DASHBOARD_ROUTER,
        as: MeasurementPage,
    },
    {
        description: '量身詳細',
        static: true,
        path: MEASURE_DETAIL_ROUTER,
        href: MEASURE_DETAIL_ROUTER,
        as: MeasurementPage,
    },
    {
        description: '量身報表',
        static: true,
        path: MEASURE_REPORT_ROUTER,
        href: MEASURE_REPORT_ROUTER,
        as: MeasurementPage,
    },
    {
        description: '量身結果',
        static: true,
        path: MEASURE_RESULT_ROUTER,
        href: MEASURE_RESULT_ROUTER,
        as: MeasurementPage,
    },
    {
        description: '成績單',
        static: true,
        path: MEASURE_TRANSCRIPT_ROUTER,
        href: MEASURE_TRANSCRIPT_ROUTER,
        as: MeasurementPage,
    },
    {
        description: '評估表',
        static: true,
        path: MEASURE_EVALUATION_ROUTER,
        href: MEASURE_EVALUATION_ROUTER,
        as: MeasurementPage,
    },
];

export default MeasurementRouter;
